import { useRef, useState, type ReactNode, type MouseEvent } from 'react';
import { Dialog } from 'react-aria-components';
import { Popover } from './components/Popover';
import { Button, type ButtonProps } from './components/buttons/Button';
import { cn } from './components/utils';
import type { FocusableElement } from '@react-types/shared';

export function IconButtonPopover({
	popoverText,
	popoverClassName,
	...props
}: {
	popoverText: string | ReactNode;
	popoverClassName?: string;
} & ButtonProps) {
	const triggerRef = useRef<HTMLButtonElement>(null);
	const [isOpen, setIsOpen] = useState(false);

	const onClick = (e: MouseEvent<FocusableElement>) => {
		e.stopPropagation();
		setIsOpen(v => !v);
	};
	return (
		<>
			<Button {...props} ref={triggerRef} onClick={onClick} />
			<Popover triggerRef={triggerRef} isOpen={isOpen} onOpenChange={setIsOpen} showArrow className={cn('max-w-xs p-4', popoverClassName)}>
				<Dialog aria-label={props['aria-label']} className="outline-none">
					{popoverText}
				</Dialog>
			</Popover>
		</>
	);
}
